import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "../lib/site";
import { useT } from "../lib/i18n";

const VILLES = [
  "Guéret",
  "La Souterraine",
  "Aubusson",
  "Bourganeuf",
  "Boussac",
  "Felletin",
  "Saint-Vaury",
  "Bénévent-l'Abbaye",
  "Dun-le-Palestel",
  "Sainte-Feyre",
];

export default function ServiceArea() {
  const { t } = useT();
  return (
    <section
      id="zone"
      data-testid="service-area-section"
      className="py-24 md:py-32 bg-[#1B5E20] relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-20">
        <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-[#4CAF50] blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] rounded-full bg-[#A5D6A7] blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-sm tracking-[0.25em] uppercase text-[#A5D6A7] font-medium mb-4">
              {t("serviceArea.eyebrow")}
            </div>
            <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-light tracking-tight text-white leading-tight">
              {t("serviceArea.title1")}{" "}
              <span className="font-script text-[#A5D6A7] font-semibold">
                {t("serviceArea.title2")}
              </span>{" "}
              {t("serviceArea.title3")}
            </h2>
            <p className="mt-6 text-lg text-white/80 leading-relaxed max-w-xl">
              {t("serviceArea.intro")}
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {VILLES.map((v) => (
                <span
                  key={v}
                  className="px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium"
                >
                  {v}
                </span>
              ))}
            </div>

            <Link
              to="/zone-intervention-creuse-et-limitrophes"
              data-testid="zone-intervention-link"
              className="mt-6 inline-flex items-center gap-2 text-[#A5D6A7] hover:text-white text-sm font-medium underline underline-offset-4 transition-colors"
            >
              Voir aussi nos interventions dans les départements limitrophes (87 · 36 · 03)
              <ArrowRight className="w-4 h-4" />
            </Link>

            <div className="mt-10 flex flex-wrap gap-6">
              <a
                href={`tel:${SITE.phoneRaw}`}
                data-testid="zone-phone"
                className="flex items-center gap-3 text-white hover:text-[#A5D6A7] transition-colors"
              >
                <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Phone className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider opacity-70">
                    {t("serviceArea.phoneLabel")}
                  </div>
                  <div className="font-['Outfit'] font-semibold">
                    {SITE.phone}
                  </div>
                </div>
              </a>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="zone-email"
                className="flex items-center gap-3 text-white hover:text-[#A5D6A7] transition-colors"
              >
                <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Mail className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider opacity-70">
                    {t("serviceArea.emailLabel")}
                  </div>
                  <div className="font-['Outfit'] font-semibold">
                    {SITE.email}
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-[2.5rem] bg-white/5 backdrop-blur-sm border border-white/20 p-8 flex items-center justify-center">
              <div className="relative w-full h-full flex items-center justify-center">
                <MapPin className="w-32 h-32 text-[#A5D6A7] animate-float" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-48 h-48 rounded-full border-2 border-dashed border-white/30 animate-pulse" />
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-72 h-72 rounded-full border border-white/20" />
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white rounded-2xl px-6 py-4 shadow-2xl">
              <div className="text-center">
                <div className="font-['Outfit'] text-3xl font-bold text-[#1B5E20]">
                  23
                </div>
                <div className="text-xs uppercase tracking-wider text-[#5C705E]">
                  {t("serviceArea.deptLabel")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
